<app-navbar title="Automatyczne nazwy">
	<button class="btn btn-primary me-4" (click)="showAdd()"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<app-simple-component
	[selectedElement]="data"
	(submited)="submit()"
	(deleted)="deleteReturn($event)"
	deleteType="delete"
>
	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="name" name="name" [(ngModel)]="data.name" required />
		<label for="name">Nazwa</label>
	</div>
	<div class="form-floating mb-3">
		<select class="form-select" id="type" name="operation" [(ngModel)]="data.operation" required>
			<option [value]="item.id" *ngFor="let item of operations">
				{{ item.name }}
			</option>
		</select>
		<label for="type">Operacja</label>
	</div>
	<div class="form-floating">
		<select class="form-select" id="type" name="type" [(ngModel)]="data.type" required>
			<option [value]="item.id" *ngFor="let item of types">
				{{ item.name }}
			</option>
		</select>
		<label for="type">Rodzaj</label>
	</div>
</app-simple-component>

<app-dynamic-table
	[elements]="elements"
	[tableRows]="tableRows"
	[haveLink]="false"
	[haveButton]="true"
	(buttonClicked)="selectItem($event)"
></app-dynamic-table>
